import { DomUtils } from './utils';

class Swipers {
    constructor(Swiper) {
        if (typeof Swiper == 'undefined') {
            return;
        }

        this.viewportWidth = DomUtils.getViewportWidth();
        this.vw = this.viewportWidth / 100;
        this.createSwiperCards();
    }

    createSwiperCards() {
        const els = document.querySelectorAll('.cards-swiper[data-mobile-swiper]');
        if (!els.length || this.viewportWidth >= 600) return;

        els.forEach((el) => {
            new Swiper(el, {
                slidesPerView: 1.1,
                spaceBetween: 16,
                // slidesOffsetAfter: this.vw * 5,
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true
                }
            });
        });
    }
}
new Swipers(Swiper);
